export function sortRowsArray(a: string, b: string): number {
  const aN = Number(a) % 2 === 1 ? Number(a) : -Number(a);
  const bN = Number(b) % 2 === 1 ? Number(b) : -Number(b);
  return aN - bN;
}
